<template>
  <div class="animated fadeIn" v-if="pageLoaded">
    <div v-if="pageLoaded">
      <span v-show="false">{{ reactivity }}</span>
      <!-- loading component -->
      <Loading />
      <b-alert
        v-model="showTop"
        class="position-fixed fixed-top m-0 mt-9 rounded-0 bg-purple text-white text-center border-0"
        style="z-index: 2000; opacity: 60%"
        dir="rtl"
      >
        پیشنویس ثبت شد!
      </b-alert>
      <b-card>
        <b-card
          v-if="
            (demand.status == 'نیاز به تکمیل / اصلاح' ||
              demand.status == 'پذیرش اولیه' ||
              demand.status == 'پیش نویس') &&
            demand.adminMessage
          "
          header-bg-variant="danger"
          header-text-variant="white"
          header="اصلاحات مورد نیاز"
          style="border: 0"
          class="shadow p-3 mb-5 bg-white rounded mt-0"
          >{{ demand.adminMessage }}</b-card
        >
        <div class="d-flex justify-content-center mt-3"></div>

        <b-card-body>
          <b-card header-bg-variant="default" class="border-0 shadow-sm">
            <template v-slot:header>
              <h4 class="mb-0">تکمیل اطلاعات پژوهشی دانشگاه</h4>
            </template>

            <!-- finalize -->
            <b-card
              style="border: 0"
              class="shadow p-3 mb-5 bg-white rounded mt-0"
              v-if="
                isFinalize ||
                demand.status == 'ارسال نامه تاییدیه' ||
                demand.status == 'تایید نهایی'
              "
            >
              <div class="row">
                <div class="col">
                  <h4 class="mb-0">بارگذاری نامه تاییدیه</h4>
                </div>
              </div>
              <b-row class="border rounded mb-3 p-3 bg-light" align-v="center">
                <b-col cols="auto">
                  <b-icon
                    icon="exclamation-triangle-fill"
                    variant="warning"
                    font-scale="2"
                    class="ml-3"
                  ></b-icon>
                </b-col>
                <b-col>
                  <p class="font-weight-bold text-danger mb-2">تذکر:</p>
                  <ol class="pl-3">
                    <li>
                      1. نامه می‌بایست در سربرگ رسمی مجموعه (دانشگاه/ دانشکده/
                      سازمان/ پژوهشگاه/پژوهشکده و...) ارسال شود.
                    </li>
                    <li>
                      2. نامه با امضاء معاون محترم تحقیقات و فناوری (دانشگاه‌های
                      ذیل وزارت بهداشت، درمان و آموزش پزشکی) و روئسای محترم
                      دانشگاه‌ها (دانشگاه‌های ذیل وزارت علوم، تحقیقات و فناوری و
                      جهاد دانشگاهی) ارسال شود.
                    </li>
                    <li>
                      3. هر دانشگاه می‌بایست نامه را خطاب به وزارتخانه‌ای که
                      دانشگاه ذیل آن وزارتخانه قرار دارد ارسال نماید (معاون
                      پژوهشی وزارت علوم، تحقیقات و فناوری یا معاون تحقیقات و
                      فناوری وزارت بهداشت، درمان و آموزش پزشکی یا معاون پژوهش و
                      فناوری سازمان جهاد دانشگاهی).
                    </li>
                    <li>
                      4. در خصوص تکمیل جدول مندرج در نامه، می‌بایست موضوعات و
                      محورهایی که برای دانشگاه در سامانه مصوب شده است اضافه شود.
                      در غیر این صورت نامه فاقد اعتبار خواهد بود.
                    </li>
                  </ol>
                </b-col>
              </b-row>

              <b-row class="mb-3" align-v="center">
                <b-col cols="auto">
                  <b-button
                    class="primary white--text"
                    href="https://api.biodcportal.com/setad/public/%D9%86%D9%85%D9%88%D9%86%D9%87%20%D9%86%D8%A7%D9%85%D9%87%20%D8%AC%D9%87%D8%A7%D8%AF.doc"
                    target="_blank"
                  >
                    دریافت نمونه نامه جهاد
                  </b-button>
                </b-col>
                <b-col cols="auto">
                  <b-button
                    class="primary white--text"
                    href="https://api.biodcportal.com/setad/public/%D9%86%D9%85%D9%88%D9%86%D9%87%20%D9%86%D8%A7%D9%85%D9%87%20%D8%AF%D8%A7%D9%86%D8%B4%DA%AF%D8%A7%D9%87.doc"
                    target="_blank"
                  >
                    دریافت نمونه نامه دانشگاهی
                  </b-button>
                </b-col>
              </b-row>

              <b-form-group
                label="نامه تاییدیه"
                class="my-3"
                :class="Object.keys(finalLetterFileData).length ? 'done' : ''"
              >
                <b-form-file
                  :state="Boolean(Object.keys(finalLetterFileData).length)"
                  :disabled="
                    Boolean(Object.keys(finalLetterFileData).length) ||
                    demand.status == 'ارسال نامه تاییدیه'
                  "
                  @input="finalLetterUploadFile(finalLetterFile)"
                  v-model="finalLetterFile"
                  browse-text="بارگذاری"
                  :placeholder="
                    finalLetterFileData
                      ? finalLetterFileData.name
                      : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                  "
                ></b-form-file>
              </b-form-group>
              <b-form-group>
                <b-col>
                  <b-progress
                    v-if="finalLetterFileData.showProgress"
                    :value="finalLetterFileData.uploadPercentage"
                    :max="max"
                    show-progress
                    :animated="finalLetterFileData.striped"
                    :variant="finalLetterFileData.variant"
                  ></b-progress>
                  <br />
                  <b-row>
                    <b-col>
                      <div
                        style="color: green"
                        v-if="finalLetterFileData.isUploaded"
                        color="green"
                      >
                        فایل جدید با موفقیت آپلود شد.
                      </div>
                    </b-col>
                    <b-col>
                      <b-row
                        align-h="end"
                        v-if="Object.keys(finalLetterFileData).length"
                      >
                        <span class="mt-3 ml-2" style="float: left"
                          ><a
                            class="btn btn-success white--text"
                            :href="finalLetterFileData.url"
                            target="_blank"
                            >دریافت</a
                          ></span
                        >
                        <b-button
                          style="height: 35px; float: left"
                          class="btn ml-2 mt-3"
                          variant="danger"
                          :disabled="demand.status == 'ارسال نامه تاییدیه'"
                          @click="
                            finalLetterFile = null;
                            finalLetterFileData = {};
                          "
                          >حذف</b-button
                        >
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-form-group>
              <div
                class="d-flex justify-content-center mt-3"
                v-if="!notEditable || isFinalize"
              >
                <b-button
                  :disabled="finalizeButton"
                  v-if="isFinalize"
                  class="mx-1"
                  variant="primary"
                  @click="finalizeDialog = true"
                  >ثبت نامه تاییدیه</b-button
                >
              </div>
            </b-card>

            <b-card
              header-bg-variant="green"
              header-text-variant="white"
              header="براساس تحلیل داده‌های علمی و پژوهشی، حوزه پیشنهادی  ماموریت در
              فناوری‌های زیستی به شرح زیر است:"
              style="border: 0"
              class="shadow p-3 mb-5 bg-white rounded mt-0"
            >
              <div v-if="uniCats.length">
                <ol class="p-2">
                  <li v-for="(item, index) in uniCats" :key="item.id">
                    {{ index + 1 }}. {{ item.name }}
                  </li>
                </ol>
              </div>
              <div v-else>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2 text-danger">
                  موضوع فعالیت برای شما تعریف نشده است. لطفا با کارشناسان ستاد
                  زیست فناوری تماس حاصل فرمایید.
                </p>
              </div></b-card
            >

            <b-card-text>
              <b-card
                style="border: 0"
                class="shadow p-3 mb-5 bg-white rounded mt-0"
              >
                <div class="row">
                  <div class="col">
                    <h5 class="mb-0">
                      آیا ماموریت پیشنهادی سامانه مورد تایید دانشگاه است؟
                    </h5>
                  </div>
                </div>
                <div class="row">
                  <b-form-group>
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        @change="
                          handleConfirmCheckboxClick(),
                            getConfirmMehvarByCats(),
                            checkConfirm()
                        "
                        v-model="isConfirmed"
                        :disabled="notEditable || uniCatsDisabled"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6>
                          بله، ماموریت فوق با فعالیت‌های دانشگاه هماهنگ است.
                        </h6></label
                      >
                    </div>
                  </b-form-group>
                </div>
                <div class="row">
                  <b-form-group>
                    <div class="d-flex" dir="rtl">
                      <b-form-checkbox
                        @change="handleChangeCheckboxClick(), checkNotConfirm()"
                        v-model="isChange"
                        :disabled="notEditable || uniCatsDisabled"
                      ></b-form-checkbox>
                      <label class="ml-2"
                        ><h6>
                          خیر، دانشگاه حوزه دیگری را به عنوان ماموریت اصلی
                          پیشنهاد می‌دهد.
                        </h6></label
                      >
                    </div>
                  </b-form-group>
                </div></b-card
              >

              <!-- isConfirmed -->
              <b-card
                style="border: 0; background-color: #e8f6f3"
                class="shadow p-3 mb-5 rounded mt-0"
                v-if="isConfirmed && showMehvarSelection"
              >
                <div class="row">
                  <div class="col">
                    <h5 class="mb-0">
                      لطفا محور(های) متناسب با موضوعی را که به عنوان ماموریت
                      اصلی دانشگاه پیشنهاد شده است، از لیست زیر انتخاب نمایید.
                    </h5>
                  </div>
                </div>

                <b-form-group class="my-3">
                  <Select2
                    v-model="uniMehvarIds"
                    :options="mehvars"
                    :settings="{ width: '100%', multiple: true }"
                    :disabled="notEditable"
                  ></Select2>
                </b-form-group>
                <div class="d-flex justify-content-center mt-3">
                  <b-button
                    :disabled="!uniMehvarIds.length || notEditable"
                    class="mx-1"
                    variant="danger"
                    @click="removeMehvarIds(), (isProposed = false)"
                    >حذف</b-button
                  >
                  <b-button
                    :disabled="!uniMehvarIds.length || notEditable"
                    class="mx-1"
                    variant="primary"
                    @click="isProposed = true"
                    >ادامه</b-button
                  >
                </div>
              </b-card>
              <b-card
                style="border: 0"
                class="shadow p-3 mb-5 bg-white rounded mt-0"
                v-if="isConfirmed && isProposed && showMehvarSelection"
              >
                <b-row class="border mb-2 pt-2 my-1" align-v="center">
                  <i
                    class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                    aria-hidden="true"
                  ></i>
                  <p class="mt-2 ml-2 text-danger">
                    تذکر: لطفا تمامی موارد قرمز رنگ را به همراه حداقل یک مقاله
                    به منظور بررسی حوزه‌های فعالیت دانشگاه تکمیل نمایید.
                    <br />
                    توجه فرمایید که تنها فایل‌هایی با فرمت‌های .png, .jpg,
                    .jpeg, .pdf, .doc, .docx, .xls و .xlsx قابل قبول هستند و
                    امکان بارگذاری فایل rar وجود ندارد.
                    <br />
                    همچنین اندازه فایل‌ها بیشتر از 5 مگ نباشد.
                  </p>
                </b-row>
                <div class="row">
                  <div class="col">
                    <h5 class="mb-0">
                      لطفا مستندات زیر را برای تایید ماموریت تعیین شده بارگذاری
                      نمایید:
                    </h5>
                  </div>
                </div>
                <b-form-group
                  label="خلاصه پروژه‌های پژوهشی"
                  class="my-3"
                  :class="
                    Object.keys(researchAbstractFileData).length ? 'done' : ''
                  "
                >
                  <b-form-file
                    :state="
                      Boolean(Object.keys(researchAbstractFileData).length)
                    "
                    :disabled="
                      Boolean(Object.keys(researchAbstractFileData).length) ||
                      notEditable
                    "
                    @input="researchUploadFile(researchAbstractFile)"
                    v-model="researchAbstractFile"
                    browse-text="بارگذاری"
                    :placeholder="
                      researchAbstractFileData
                        ? researchAbstractFileData.name
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="researchAbstractFileData.showProgress"
                      :value="researchAbstractFileData.uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="researchAbstractFileData.striped"
                      :variant="researchAbstractFileData.variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="researchAbstractFileData.isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row
                          align-h="end"
                          v-if="Object.keys(researchAbstractFileData).length"
                        >
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="researchAbstractFileData.url"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="
                              researchAbstractFile = null;
                              researchAbstractFileData = {};
                            "
                            :disabled="notEditable"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
                <hr />
                <b-form-group label="خلاصه پروژه‌های صنعتی" class="my-3">
                  <b-form-file
                    :disabled="
                      Boolean(Object.keys(industryAbstractFileData).length) ||
                      notEditable
                    "
                    @input="industryUploadFile(industryAbstractFile)"
                    v-model="industryAbstractFile"
                    browse-text="بارگذاری"
                    :placeholder="
                      industryAbstractFileData
                        ? industryAbstractFileData.name
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="industryAbstractFileData.showProgress"
                      :value="industryAbstractFileData.uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="industryAbstractFileData.striped"
                      :variant="industryAbstractFileData.variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="industryAbstractFileData.isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row
                          align-h="end"
                          v-if="Object.keys(industryAbstractFileData).length"
                        >
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="industryAbstractFileData.url"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="
                              industryAbstractFile = null;
                              industryAbstractFileData = {};
                            "
                            :disabled="notEditable"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
                <hr />
                <b-form-group
                  label="معرفی مراکز یا آزمایشگاه‌های فعال در حوزه پیشنهادی"
                  class="my-3"
                  :class="
                    Object.keys(centersAbstractFileData).length ? 'done' : ''
                  "
                >
                  <b-form-file
                    :state="
                      Boolean(Object.keys(centersAbstractFileData).length)
                    "
                    :disabled="
                      Boolean(Object.keys(centersAbstractFileData).length) ||
                      notEditable
                    "
                    @input="centerUploadFile(centersAbstractFile)"
                    v-model="centersAbstractFile"
                    browse-text="بارگذاری"
                    :placeholder="
                      centersAbstractFileData
                        ? centersAbstractFileData.name
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="centersAbstractFileData.showProgress"
                      :value="centersAbstractFileData.uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="centersAbstractFileData.striped"
                      :variant="centersAbstractFileData.variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="centersAbstractFileData.isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row
                          align-h="end"
                          v-if="Object.keys(centersAbstractFileData).length"
                        >
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="centersAbstractFileData.url"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="
                              centersAbstractFile = null;
                              centersAbstractFileData = {};
                            "
                            :disabled="notEditable"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
                <hr />
                <b-form-group
                  label="معرفی اعضای هیئت علمی شاخص"
                  class="my-3"
                  :class="
                    Object.keys(committeesAbstractFileData).length ? 'done' : ''
                  "
                >
                  <b-form-file
                    :state="
                      Boolean(Object.keys(committeesAbstractFileData).length)
                    "
                    :disabled="
                      Boolean(Object.keys(committeesAbstractFileData).length) ||
                      notEditable
                    "
                    @input="committeeUploadFile(committeesAbstractFile)"
                    v-model="committeesAbstractFile"
                    browse-text="بارگذاری"
                    :placeholder="
                      committeesAbstractFileData
                        ? committeesAbstractFileData.name
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="committeesAbstractFileData.showProgress"
                      :value="committeesAbstractFileData.uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="committeesAbstractFileData.striped"
                      :variant="committeesAbstractFileData.variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="committeesAbstractFileData.isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row
                          align-h="end"
                          v-if="Object.keys(committeesAbstractFileData).length"
                        >
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="committeesAbstractFileData.url"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="
                              committeesAbstractFile = null;
                              committeesAbstractFileData = {};
                            "
                            :disabled="notEditable"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
                <hr />
                <b-row class="border mb-2 pt-2 my-1" align-v="center">
                  <i
                    class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                    aria-hidden="true"
                  ></i>
                  <p class="mt-2 ml-2 text-danger">
                    تذکر: مسئولیت بررسی و صحت DOI وارد شده بر عهده دانشگاه
                    می‌باشد.
                    <br />
                    ممکن است برخی شناسه‌ها در سیستم تعریف نشده باشد؛ کافیست
                    دانشگاه از صحت اطلاعات وارد شده مطمئن باشد.
                    <br />
                    توجه فرمایید مقالات Q1 و Q2 و در بازه 2015 تا 2025 باشند.
                  </p>
                </b-row>
                <b-button
                  @click="addArticleDoi()"
                  variant="success"
                  class="mb-3"
                  :disabled="notEditable"
                  >افزودن</b-button
                >
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="articles"
                  :fields="articlesField"
                  empty-text="مقاله‌ای برای نمایش وجود ندارد"
                  class="table table-secondary mb-2"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="primary"
                        class="mr-2"
                        :disabled="!data.item.doi.length"
                        @click="doiCheck(data.index)"
                        >بررسی</b-button
                      >
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delArticleDoi(data.index)"
                        :disabled="notEditable"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(doi)="data">
                    <div>
                      <b-form-input
                        dir="ltr"
                        trim
                        v-model="data.item.doi"
                        type="text"
                        :disabled="notEditable"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
                <hr />
                <b-row class="mb-2 pt-2 my-1" align-v="center">
                  <h5 class="mt-2 ml-2">
                    سایر مستندات (گرنت‌های تحقیقاتی ملی و بین‌المللی/شرکت‌های
                    دانش‌بنیان وابسته/ثبت اختراع و پتنت‌های بین‌المللی)
                  </h5>
                </b-row>
                <b-button
                  @click="addOtherFile()"
                  variant="success"
                  class="mb-3"
                  :disabled="notEditable"
                  >افزودن</b-button
                >
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="otherFiles"
                  :fields="otherFilesField"
                  empty-text="فایلی برای نمایش وجود ندارد"
                  class="table table-secondary mb-2"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <b-row>
                      <b-col cols="8">
                        <b-form-file
                          v-model="data.item.rawFile"
                          @input="
                            otherUploadFile(data.item.rawFile, data.index)
                          "
                          browse-text="بارگذاری"
                          button
                          button-variant="primary"
                          no-preview
                          :disabled="notEditable"
                        ></b-form-file>
                        <b-col>
                          <b-progress
                            v-if="data.item.file.showProgress"
                            :value="data.item.file.uploadPercentage"
                            :max="max"
                            show-progress
                            :animated="data.item.file.striped"
                            :variant="data.item.file.variant"
                          ></b-progress>
                          <br />
                          <b-row>
                            <b-col>
                              <div
                                style="color: green"
                                v-if="data.item.file.isUploaded"
                                color="green"
                              >
                                فایل جدید با موفقیت آپلود شد.
                              </div>
                            </b-col>
                            <b-col>
                              <b-row
                                align-h="end"
                                v-if="Object.keys(data.item.file).length"
                              >
                                <span class="mt-3 ml-2" style="float: left"
                                  ><a
                                    class="btn btn-success white--text"
                                    :href="data.item.file.url"
                                    target="_blank"
                                    >دریافت</a
                                  ></span
                                >
                                <b-button
                                  style="height: 35px; float: left"
                                  class="btn ml-2 mt-3"
                                  variant="danger"
                                  @click="
                                    data.item.rawFile = null;
                                    data.item.fileId = null;
                                    data.item.file = {};
                                    data.item.file.isUploaded = false;
                                    data.item.file.uploadPercentage = 0;
                                  "
                                  :disabled="notEditable"
                                  >حذف</b-button
                                >
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                      <b-col cols="4">
                        <b-button
                          variant="danger"
                          class="mr-2"
                          @click="delOtherFile(data.index)"
                          :disabled="notEditable"
                          >x</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div>
                      <b-form-input
                        dir="ltr"
                        trim
                        v-model="data.item.description"
                        type="text"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
              </b-card>
              <b-card
                style="border: 0; background-color: #96e8fd"
                class="shadow p-3 mb-5 rounded mt-0"
                v-if="isConfirmed && isProposed && showMehvarSelection"
              >
                <div class="row">
                  <div class="col">
                    <h5 class="mb-0">
                      لطفا به منظور ارتباط بهتر با دانشگاه، اطلاعات زیر را تکمیل
                      نمایید.
                    </h5>
                  </div>
                </div>

                <b-form-group class="my-3">
                  <div class="my-3">
                    <b-form-group
                      label="نام رابط"
                      label-for="contact-name"
                      :class="contanctName.length ? 'done' : 'required'"
                    >
                      <b-form-input
                        id="contact-name"
                        dir="rtl"
                        trim
                        v-model="contanctName"
                        type="text"
                        :disabled="notEditable"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      label="سمت رابط"
                      label-for="contact-role"
                      :class="contanctRole.length ? 'done' : 'required'"
                    >
                      <b-form-input
                        id="contact-role"
                        dir="rtl"
                        trim
                        v-model="contanctRole"
                        type="text"
                        :disabled="notEditable"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      label="شماره همراه رابط"
                      label-for="contact-mobile"
                      :class="isMobileValid ? 'done' : 'required'"
                    >
                      <b-form-input
                        dir="rtl"
                        trim
                        v-model="contanctMobile"
                        type="number"
                        :disabled="notEditable"
                        :state="isMobileValid"
                      />
                      <b-form-invalid-feedback v-if="!isMobileValid">
                        شماره موبایل نامعتبر است
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </b-form-group>
              </b-card>

              <!-- isChange -->
              <!-- Select other cat -->
              <b-card
                style="border: 0"
                class="shadow p-3 mb-5 bg-white rounded mt-0"
                v-if="isChange"
              >
                <div class="row">
                  <div class="col">
                    <h5 class="mb-0">
                      لطفا موضوعی که دانشگاه آن را ماموریت اصلی خود می‌داند، از
                      لیست زیر انتخاب نمایید. توجه فرمایید که شما تنها می‌توانید
                      حداکثر دو موضوع را انتخاب نمایید.
                    </h5>
                  </div>
                </div>

                <b-form-group class="my-3">
                  <Select2
                    v-model="uniCatIds"
                    :options="categories"
                    :settings="{ width: '100%', multiple: true }"
                    :disabled="showMehvarSelection || notEditable"
                    @select="onSelectCategory"
                  ></Select2>
                </b-form-group>
                <div class="d-flex justify-content-center mt-3">
                  <b-button
                    :disabled="!uniCatIds.length || notEditable"
                    class="mx-1"
                    variant="danger"
                    @click="removeCatIds()"
                    >حذف</b-button
                  >
                  <b-button
                    :disabled="!uniCatIds.length || notEditable"
                    class="mx-1"
                    variant="primary"
                    @click="getMehvarByCats(), (showMehvarSelection = true)"
                    >ادامه</b-button
                  >
                </div>
              </b-card>
              <b-card
                style="border: 0; background-color: #e8f6f3"
                class="shadow p-3 mb-5 rounded mt-0"
                v-if="isChange && showMehvarSelection"
              >
                <div class="row">
                  <div class="col">
                    <h5 class="mb-0">
                      لطفا محور متناسب با موضوعی که دانشگاه آن را ماموریت اصلی
                      خود می‌داند، از لیست زیر انتخاب نمایید.
                    </h5>
                  </div>
                </div>

                <b-form-group class="my-3">
                  <Select2
                    v-model="uniMehvarIds"
                    :options="mehvars"
                    :settings="{ width: '100%', multiple: true }"
                    :disabled="notEditable"
                  ></Select2>
                </b-form-group>
                <div class="d-flex justify-content-center mt-3">
                  <b-button
                    class="mx-1"
                    variant="success"
                    @click="showMehvarSelection = false"
                    :disabled="notEditable"
                    >بازگشت</b-button
                  >
                  <b-button
                    :disabled="!uniMehvarIds.length || notEditable"
                    class="mx-1"
                    variant="danger"
                    @click="removeMehvarIds()"
                    >حذف</b-button
                  >
                  <b-button
                    :disabled="!uniMehvarIds.length || notEditable"
                    class="mx-1"
                    variant="primary"
                    @click="isProposed = true"
                    >ادامه</b-button
                  >
                </div>
              </b-card>
              <!-- complete proposal -->
              <b-card
                style="border: 0"
                class="shadow p-3 mb-5 bg-white rounded mt-0"
                v-if="isChange && isProposed && showMehvarSelection"
              >
                <b-row class="border mb-2 pt-2 my-1" align-v="center">
                  <i
                    class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                    aria-hidden="true"
                  ></i>
                  <p class="mt-2 ml-2 text-danger">
                    تذکر: لطفا تمامی موارد قرمز رنگ را به همراه حداقل یک مقاله
                    به منظور بررسی حوزه‌های فعالیت دانشگاه تکمیل نمایید.
                    <br />
                    توجه فرمایید که تنها فایل‌هایی با فرمت‌های .png, .jpg,
                    .jpeg, .pdf, .doc, .docx, .xls و .xlsx قابل قبول هستند و
                    امکان بارگذاری فایل rar وجود ندارد.
                    <br />
                    همچنین اندازه فایل‌ها بیشتر از 5 مگ نباشد.
                  </p>
                </b-row>
                <div class="row">
                  <div class="col">
                    <h5 class="mb-0">
                      لطفا مستندات زیر را برای تایید ماموریت پیشنهادی خود
                      بارگذاری نمایید:
                    </h5>
                  </div>
                </div>
                <b-form-group
                  label="خلاصه پروژه‌های پژوهشی یا صنعتی"
                  class="my-3"
                  :class="
                    Object.keys(researchAbstractFileData).length ? 'done' : ''
                  "
                >
                  <b-form-file
                    :state="
                      Boolean(Object.keys(researchAbstractFileData).length)
                    "
                    :disabled="
                      Boolean(Object.keys(researchAbstractFileData).length) ||
                      notEditable
                    "
                    @input="researchUploadFile(researchAbstractFile)"
                    v-model="researchAbstractFile"
                    browse-text="بارگذاری"
                    :placeholder="
                      researchAbstractFileData
                        ? researchAbstractFileData.name
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="researchAbstractFileData.showProgress"
                      :value="researchAbstractFileData.uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="researchAbstractFileData.striped"
                      :variant="researchAbstractFileData.variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="researchAbstractFileData.isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row
                          align-h="end"
                          v-if="Object.keys(researchAbstractFileData).length"
                        >
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="researchAbstractFileData.url"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="
                              researchAbstractFile = null;
                              researchAbstractFileData = {};
                            "
                            :disabled="notEditable"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
                <hr />
                <b-form-group label="خلاصه پروژه‌های صنعتی" class="my-3">
                  <b-form-file
                    :disabled="
                      Boolean(Object.keys(industryAbstractFileData).length) ||
                      notEditable
                    "
                    @input="industryUploadFile(industryAbstractFile)"
                    v-model="industryAbstractFile"
                    browse-text="بارگذاری"
                    :placeholder="
                      industryAbstractFileData
                        ? industryAbstractFileData.name
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="industryAbstractFileData.showProgress"
                      :value="industryAbstractFileData.uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="industryAbstractFileData.striped"
                      :variant="industryAbstractFileData.variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="industryAbstractFileData.isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row
                          align-h="end"
                          v-if="Object.keys(industryAbstractFileData).length"
                        >
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="industryAbstractFileData.url"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="
                              industryAbstractFile = null;
                              industryAbstractFileData = {};
                            "
                            :disabled="notEditable"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
                <hr />
                <b-form-group
                  label="معرفی مراکز یا آزمایشگاه‌های فعال در حوزه پیشنهادی"
                  class="my-3"
                  :class="
                    Object.keys(centersAbstractFileData).length ? 'done' : ''
                  "
                >
                  <b-form-file
                    :state="
                      Boolean(Object.keys(centersAbstractFileData).length)
                    "
                    :disabled="
                      Boolean(Object.keys(centersAbstractFileData).length) ||
                      notEditable
                    "
                    @input="centerUploadFile(centersAbstractFile)"
                    v-model="centersAbstractFile"
                    browse-text="بارگذاری"
                    :placeholder="
                      centersAbstractFileData
                        ? centersAbstractFileData.name
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="centersAbstractFileData.showProgress"
                      :value="centersAbstractFileData.uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="centersAbstractFileData.striped"
                      :variant="centersAbstractFileData.variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="centersAbstractFileData.isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row
                          align-h="end"
                          v-if="Object.keys(centersAbstractFileData).length"
                        >
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="centersAbstractFileData.url"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="
                              centersAbstractFile = null;
                              centersAbstractFileData = {};
                            "
                            :disabled="notEditable"
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
                <hr />
                <b-form-group
                  label="معرفی اعضای هیئت علمی شاخص"
                  class="my-3"
                  :class="
                    Object.keys(committeesAbstractFileData).length ? 'done' : ''
                  "
                >
                  <b-form-file
                    :state="
                      Boolean(Object.keys(committeesAbstractFileData).length)
                    "
                    :disabled="
                      Boolean(Object.keys(committeesAbstractFileData).length) ||
                      notEditable
                    "
                    @input="committeeUploadFile(committeesAbstractFile)"
                    v-model="committeesAbstractFile"
                    browse-text="بارگذاری"
                    :placeholder="
                      committeesAbstractFileData
                        ? committeesAbstractFileData.name
                        : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                    "
                  ></b-form-file>
                </b-form-group>
                <b-form-group>
                  <b-col>
                    <b-progress
                      v-if="committeesAbstractFileData.showProgress"
                      :value="committeesAbstractFileData.uploadPercentage"
                      :max="max"
                      show-progress
                      :animated="committeesAbstractFileData.striped"
                      :variant="committeesAbstractFileData.variant"
                    ></b-progress>
                    <br />
                    <b-row>
                      <b-col>
                        <div
                          style="color: green"
                          v-if="committeesAbstractFileData.isUploaded"
                          color="green"
                        >
                          فایل جدید با موفقیت آپلود شد.
                        </div>
                      </b-col>
                      <b-col>
                        <b-row
                          align-h="end"
                          v-if="Object.keys(committeesAbstractFileData).length"
                        >
                          <span class="mt-3 ml-2" style="float: left"
                            ><a
                              class="btn btn-success white--text"
                              :href="committeesAbstractFileData.url"
                              target="_blank"
                              >دریافت</a
                            ></span
                          >
                          <b-button
                            style="height: 35px; float: left"
                            class="btn ml-2 mt-3"
                            variant="danger"
                            @click="
                              committeesAbstractFile = null;
                              committeesAbstractFileData = {};
                            "
                            :disabled="notEditable"
                            s
                            >حذف</b-button
                          >
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-form-group>
                <hr />
                <b-row class="border mb-2 pt-2 my-1" align-v="center">
                  <i
                    class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
                    aria-hidden="true"
                  ></i>
                  <p class="mt-2 ml-2 text-danger">
                    تذکر: مسئولیت بررسی و صحت DOI وارد شده بر عهده دانشگاه
                    می‌باشد.
                    <br />
                    ممکن است برخی شناسه‌ها در سیستم تعریف نشده باشد؛ کافیست
                    دانشگاه از صحت اطلاعات وارد شده مطمئن باشد.
                    <br />
                    توجه فرمایید مقالات Q1 و Q2 و در بازه 2015 تا 2025 باشند.
                  </p>
                </b-row>
                <b-button
                  @click="addArticleDoi()"
                  variant="success"
                  class="mb-3"
                  :disabled="notEditable"
                  >افزودن</b-button
                >
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="articles"
                  :fields="articlesField"
                  empty-text="مقاله‌ای برای نمایش وجود ندارد"
                  class="table table-secondary mb-2"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <div>
                      <b-button
                        variant="primary"
                        class="mr-2"
                        :disabled="!data.item.doi.length"
                        @click="doiCheck(data.index)"
                        >بررسی</b-button
                      >
                      <b-button
                        variant="danger"
                        class="mr-2"
                        @click="delArticleDoi(data.index)"
                        :disabled="notEditable"
                        >x</b-button
                      >
                    </div>
                  </template>

                  <template v-slot:cell(doi)="data">
                    <div>
                      <b-form-input
                        dir="ltr"
                        trim
                        v-model="data.item.doi"
                        type="text"
                        :disabled="notEditable"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>

                <hr />
                <b-row class="mb-2 pt-2 my-1" align-v="center">
                  <h5 class="mt-2 ml-2">
                    سایر مستندات (گرنت‌های تحقیقاتی ملی و بین‌المللی/شرکت‌های
                    دانش‌بنیان وابسته/ثبت اختراع و پتنت‌های بین‌المللی)
                  </h5>
                </b-row>
                <b-button
                  @click="addOtherFile()"
                  variant="success"
                  class="mb-3"
                  :disabled="notEditable"
                  >افزودن</b-button
                >
                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="otherFiles"
                  :fields="otherFilesField"
                  empty-text="فایلی برای نمایش وجود ندارد"
                  class="table table-secondary mb-2"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                  ],
                  <template v-slot:cell(operation)="data">
                    <b-row>
                      <b-col cols="8">
                        <b-form-file
                          v-model="data.item.rawFile"
                          @input="
                            otherUploadFile(data.item.rawFile, data.index)
                          "
                          browse-text="بارگذاری"
                          button
                          button-variant="primary"
                          no-preview
                          :disabled="notEditable"
                        ></b-form-file>
                        <b-col>
                          <b-progress
                            v-if="data.item.file.showProgress"
                            :value="data.item.file.uploadPercentage"
                            :max="max"
                            show-progress
                            :animated="data.item.file.striped"
                            :variant="data.item.file.variant"
                          ></b-progress>
                          <br />
                          <b-row>
                            <b-col>
                              <div
                                style="color: green"
                                v-if="data.item.file.isUploaded"
                                color="green"
                              >
                                فایل جدید با موفقیت آپلود شد.
                              </div>
                            </b-col>
                            <b-col>
                              <b-row
                                align-h="end"
                                v-if="Object.keys(data.item.file).length"
                              >
                                <span class="mt-3 ml-2" style="float: left"
                                  ><a
                                    class="btn btn-success white--text"
                                    :href="data.item.file.url"
                                    target="_blank"
                                    >دریافت</a
                                  ></span
                                >
                                <b-button
                                  style="height: 35px; float: left"
                                  class="btn ml-2 mt-3"
                                  variant="danger"
                                  @click="
                                    data.item.rawFile = null;
                                    data.item.fileId = null;
                                    data.item.file = {};
                                    data.item.file.isUploaded = false;
                                    data.item.file.uploadPercentage = 0;
                                  "
                                  :disabled="notEditable"
                                  >حذف</b-button
                                >
                              </b-row>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-col>
                      <b-col cols="4">
                        <b-button
                          variant="danger"
                          class="mr-2"
                          @click="delOtherFile(data.index)"
                          :disabled="notEditable"
                          >x</b-button
                        >
                      </b-col>
                    </b-row>
                  </template>

                  <template v-slot:cell(description)="data">
                    <div>
                      <b-form-input
                        dir="ltr"
                        trim
                        v-model="data.item.description"
                        type="text"
                        :disabled="notEditable"
                      ></b-form-input>
                    </div>
                  </template>
                </b-table>
              </b-card>
              <b-card
                style="border: 0; background-color: #96e8fd"
                class="shadow p-3 mb-5 rounded mt-0"
                v-if="isChange && isProposed && showMehvarSelection"
              >
                <div class="row">
                  <div class="col">
                    <h5 class="mb-0">
                      لطفا به منظور ارتباط بهتر با دانشگاه، اطلاعات زیر را تکمیل
                      نمایید.
                    </h5>
                  </div>
                </div>

                <b-form-group class="my-3">
                  <div class="my-3">
                    <b-form-group
                      label="نام رابط"
                      label-for="contact-name"
                      :class="contanctName.length ? 'done' : 'required'"
                    >
                      <b-form-input
                        id="contact-name"
                        dir="rtl"
                        trim
                        v-model="contanctName"
                        type="text"
                        :disabled="notEditable"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      label="سمت رابط"
                      label-for="contact-role"
                      :class="contanctRole.length ? 'done' : 'required'"
                    >
                      <b-form-input
                        id="contact-role"
                        dir="rtl"
                        trim
                        v-model="contanctRole"
                        type="text"
                        :disabled="notEditable"
                      ></b-form-input>
                    </b-form-group>

                    <b-form-group
                      label="شماره همراه رابط"
                      label-for="contact-mobile"
                      :class="isMobileValid ? 'done' : 'required'"
                    >
                      <b-form-input
                        dir="rtl"
                        trim
                        v-model="contanctMobile"
                        type="number"
                        :disabled="notEditable"
                        :state="isMobileValid"
                      />
                      <b-form-invalid-feedback v-if="!isMobileValid">
                        شماره موبایل نامعتبر است
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </b-form-group>
              </b-card>
            </b-card-text>
          </b-card>
        </b-card-body>

        <div
          class="d-flex justify-content-center mt-3"
          v-if="!notEditable || isFinalize"
        >
          <b-button
            :disabled="
              isSaving || !((isConfirmed || isChange) && uniMehvarIds.length)
            "
            v-if="!isFinalize"
            class="mx-1"
            variant="success"
            @click="saveDraft()"
            >ثبت پیشنویس</b-button
          >
          <b-button
            :disabled="submitButton"
            v-if="demand.status != 'نیاز به تکمیل / اصلاح' && !isFinalize"
            class="mx-1"
            variant="primary"
            @click="submitDialog = true"
            >ثبت نهایی</b-button
          >
          <b-button
            :disabled="submitButton"
            v-if="demand.status == 'نیاز به تکمیل / اصلاح' && !isFinalize"
            class="mx-1"
            variant="primary"
            @click="editDialog = true"
            >ثبت اصلاحیه</b-button
          >
        </div>
      </b-card>
      <router-view></router-view>
    </div>
    <v-dialog v-model="submitDialog" persistent width="650">
      <v-card class="dialog-card">
        <b>
          <i
            class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
            aria-hidden="true"
          ></i>
          <p class="mb-2">
            درصورت ثبت نهایی، امکان ویرایش اطلاعات وجود نخواهد داشت! آیا تمایل
            به "ثبت نهایی" دارید؟
          </p></b
        >
        <div class="d-flex justify-content-center mt-3">
          <b-button class="mx-1" variant="danger" @click="submitDialog = false"
            >خیر</b-button
          >
          <b-button class="mx-1" variant="primary" @click="submit()"
            >ثبت نهایی</b-button
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" persistent width="650">
      <v-card class="dialog-card">
        <b>
          <i
            class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
            aria-hidden="true"
          ></i>
          <p class="mb-2">
            درصورت ثبت اصلاحیه امکان ویرایش اطلاعات وجود نخواهد داشت! آیا تمایل
            به "ثبت اصلاحیه" دارید؟
          </p></b
        >
        <div class="d-flex justify-content-center mt-3">
          <b-button class="mx-1" variant="danger" @click="editDialog = false"
            >خیر</b-button
          >
          <b-button class="mx-1" variant="primary" @click="submitEdit()"
            >ثبت اصلاحیه</b-button
          >
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="finalizeDialog" persistent width="650">
      <v-card class="dialog-card">
        <b>
          <i
            class="fa fa-exclamation-triangle fa-2x text-warning mb-1 ml-3"
            aria-hidden="true"
          ></i>
          <p class="mb-2">
            درصورت ارسال نامه امکان ویرایش اطلاعات وجود نخواهد داشت! آیا تمایل
            به "ارسال نامه تاییدیه" دارید؟
          </p></b
        >
        <div class="d-flex justify-content-center mt-3">
          <b-button
            class="mx-1"
            variant="danger"
            @click="finalizeDialog = false"
            >خیر</b-button
          >
          <b-button class="mx-1" variant="primary" @click="submitFinalize()"
            >ارسال نامه</b-button
          >
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import router from "../../router"; // NOTE (IMPORT) to communication between different parts of the site
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search
export default {
  components: {
    Select2, // NOTE (COMPONENT) component of select2 plugin
  },
  data() {
    return {
      reactivity: false,
      check: false,
      fileBusy: true,
      pageLoaded: false,
      show: false,
      checkbox: "",
      busy: false,
      isSaving: false,
      color: "",
      max: 100,
      isLoaded: true,
      showTop: false,
      categories: [],
      mehvars: [],
      demand: {},
      uniCats: [],
      isConfirmed: false,
      isChange: false,
      showMehvarSelection: false,
      isProposed: false,
      researchAbstractFile: [],
      researchAbstractFileData: {},
      industryAbstractFile: [],
      industryAbstractFileData: {},
      centersAbstractFile: [],
      centersAbstractFileData: {},
      committeesAbstractFile: [],
      committeesAbstractFileData: {},
      articles: [{ title: "", doi: "" }],
      otherFiles: [
        {
          description: "",
          fileId: "",
          file: {},
          rawFile: [],
        },
      ],
      articlesField: [
        { key: "index", label: "#" },
        { key: "doi", label: "doi" },
        {
          key: "title",
          label: "عنوان مقاله",
        },
        { key: "operation", label: "عملیات" },
      ],
      otherFilesField: [
        { key: "index", label: "#" },
        {
          key: "description",
          label: "توضیحات",
        },
        { key: "operation", label: "عملیات" },
      ],
      uniCatIds: [],
      uniMehvarIds: [],
      notEditable: false,
      contanctName: "",
      contanctRole: "",
      contanctMobile: "",
      submitDialog: false,
      editDialog: false,
      uniCatsDisabled: false,
      isFinalize: false,
      finalLetterFile: [],
      finalLetterFileData: {},
      finalizeDialog: false,
    };
  },

  methods: {
    addArticleDoi() {
      this.articles.push({ title: "", doi: "" });
      const title = (
        <div dir="rtl">
          <h5>doi جدید افزوده شد!</h5>
          <span>لطفا doi مدنظر را وارد نمایید. </span>
        </div>
      );
      this.toast(title, "info");
    },
    delArticleDoi(doi) {
      this.articles.splice(doi, 1);
    },
    doiCheck(index) {
      this.check = !this.check;
      if (!this.articles[index].doi.length) return;
      this.$http
        .post(
          this.baseUrl + "/setad/university/demand/doi",
          { doi: this.articles[index].doi },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(
            "شناسه‌ی وارد شده\n" + this.articles[index].doi + "\n!معتبر است",
            "info"
          );
          this.articles[index].title = res.data.title;
        })
        .catch(() => {
          this.toast(
            "شناسه‌ی وارد شده\n" + this.articles[index].doi + "\n!معتبر نیست",
            "error"
          );
          this.articles[index].title = "";
        });
    },
    researchUploadFile(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.researchAbstractFileData.showProgress = true;
        this.researchAbstractFileData.variant = "info";
        this.researchAbstractFileData.uploadPercentage = 0;
        this.researchAbstractFileData.isUploaded = false;
        this.researchAbstractFileData.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/university/profile/upload", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.researchAbstractFileData.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.researchAbstractFileData.isUploaded = true;
              this.researchAbstractFileData.uploadPercentage = 100;
              this.researchAbstractFileData.striped = false;
              this.researchAbstractFileData.variant = "success";
              this.researchAbstractFileData.uploadButDisable = false;
              this.researchAbstractFileData = d.data;
              this.$forceUpdate();
              this.toast("فایل با موفقیت بارگذاری کردید.", "success");
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.researchAbstractFile = null;
            this.researchAbstractFileData.uploadPercentage = 0;
            this.researchAbstractFileData.isUploaded = false;
          });
      }
    },
    industryUploadFile(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.industryAbstractFileData.showProgress = true;
        this.industryAbstractFileData.variant = "info";
        this.industryAbstractFileData.uploadPercentage = 0;
        this.industryAbstractFileData.isUploaded = false;
        this.industryAbstractFileData.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/university/profile/upload", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.industryAbstractFileData.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.industryAbstractFileData.isUploaded = true;
              this.industryAbstractFileData.uploadPercentage = 100;
              this.industryAbstractFileData.striped = false;
              this.industryAbstractFileData.variant = "success";
              this.industryAbstractFileData.uploadButDisable = false;
              this.industryAbstractFileData = d.data;
              this.$forceUpdate();
              this.toast("فایل با موفقیت بارگذاری کردید.", "success");
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.industryAbstractFile = null;
            this.industryAbstractFileData.uploadPercentage = 0;
            this.industryAbstractFileData.isUploaded = false;
          });
      }
    },
    centerUploadFile(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.centersAbstractFileData.showProgress = true;
        this.centersAbstractFileData.variant = "info";
        this.centersAbstractFileData.uploadPercentage = 0;
        this.centersAbstractFileData.isUploaded = false;
        this.centersAbstractFileData.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/university/profile/upload", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.centersAbstractFileData.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.centersAbstractFileData.isUploaded = true;
              this.centersAbstractFileData.uploadPercentage = 100;
              this.centersAbstractFileData.striped = false;
              this.centersAbstractFileData.variant = "success";
              this.centersAbstractFileData.uploadButDisable = false;
              this.centersAbstractFileData = d.data;
              this.$forceUpdate();
              this.toast("فایل با موفقیت بارگذاری کردید.", "success");
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.centersAbstractFile = null;
            this.centersAbstractFileData.uploadPercentage = 0;
            this.centersAbstractFileData.isUploaded = false;
          });
      }
    },
    committeeUploadFile(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.committeesAbstractFileData.showProgress = true;
        this.committeesAbstractFileData.variant = "info";
        this.committeesAbstractFileData.uploadPercentage = 0;
        this.committeesAbstractFileData.isUploaded = false;
        this.committeesAbstractFileData.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/university/profile/upload", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.committeesAbstractFileData.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.committeesAbstractFileData.isUploaded = true;
              this.committeesAbstractFileData.uploadPercentage = 100;
              this.committeesAbstractFileData.striped = false;
              this.committeesAbstractFileData.variant = "success";
              this.committeesAbstractFileData.uploadButDisable = false;
              this.committeesAbstractFileData = d.data;
              this.$forceUpdate();
              this.toast("فایل با موفقیت بارگذاری کردید.", "success");
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.committeesAbstractFile = null;
            this.committeesAbstractFileData.uploadPercentage = 0;
            this.committeesAbstractFileData.isUploaded = false;
          });
      }
    },
    finalLetterUploadFile(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.finalLetterFileData.showProgress = true;
        this.finalLetterFileData.variant = "info";
        this.finalLetterFileData.uploadPercentage = 0;
        this.finalLetterFileData.isUploaded = false;
        this.finalLetterFileData.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/university/profile/upload", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.finalLetterFileData.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.finalLetterFileData.isUploaded = true;
              this.finalLetterFileData.uploadPercentage = 100;
              this.finalLetterFileData.striped = false;
              this.finalLetterFileData.variant = "success";
              this.finalLetterFileData.uploadButDisable = false;
              this.finalLetterFileData = d.data;
              this.$forceUpdate();
              this.toast("فایل با موفقیت بارگذاری کردید.", "success");
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.finalLetterFile = null;
            this.finalLetterFileData.uploadPercentage = 0;
            this.finalLetterFileData.isUploaded = false;
          });
      }
    },

    otherUploadFile(file, index) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.otherFiles[index].file.showProgress = true;
        this.otherFiles[index].file.variant = "info";
        this.otherFiles[index].file.uploadPercentage = 0;
        this.otherFiles[index].file.isUploaded = false;
        this.otherFiles[index].file.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(this.baseUrl + "/setad/university/profile/upload", formData, {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
            onUploadProgress: ((progressEvent) => {
              this.otherFiles[index].file.uploadPercentage =
                Math.round((progressEvent.loaded * 100) / progressEvent.total) -
                1;
            }).bind(this),
          })
          .then((d) => {
            if (d.status == 200) {
              this.otherFiles[index].file.isUploaded = true;
              this.otherFiles[index].file.uploadPercentage = 100;
              this.otherFiles[index].file.striped = false;
              this.otherFiles[index].file.variant = "success";
              this.otherFiles[index].file.uploadButDisable = false;
              this.otherFiles[index].file = d.data;
              this.otherFiles[index].fileId = d.data.id;
              this.$forceUpdate();
              this.toast("فایل با موفقیت بارگذاری کردید.", "success");
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.otherFiles[index].file = {};
            this.otherFiles[index].file.uploadPercentage = 0;
            this.otherFiles[index].file.isUploaded = false;
          });
      }
    },

    addOtherFile() {
      this.otherFiles.push({
        description: "",
        fileId: "",
        file: { showProgress: false },
        rawFile: "",
      });
      const title = (
        <div dir="rtl">
          <h5>فایل جدید افزوده شد!</h5>
          <span>لطفا فایل مدنظر را بارگذاری نمایید. </span>
        </div>
      );
      this.toast(title, "info");
    },
    delOtherFile(index) {
      this.otherFiles.splice(index, 1);
    },

    handleConfirmCheckboxClick() {
      this.isChange = false;
      this.isConfirmed = true;
    },
    handleChangeCheckboxClick() {
      this.isChange = true;
      this.isConfirmed = false;
    },

    saveDraft() {
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.showTop = true;
      this.isSaving = true;

      this.articles = this.articles.length
        ? this.articles.filter((x) => x.doi)
        : undefined;
      this.otherFiles = this.otherFiles.length
        ? this.otherFiles
            .filter((x) => x.fileId)
            .map((x) => {
              return { description: x.description, fileId: x.fileId };
            })
        : undefined;

      this.$http
        .patch(
          this.baseUrl + "/setad/university/demand/draft/" + this.demand.id,
          {
            isConfirmed: this.isConfirmed,
            isChange: this.isChange,
            contanctName: this.contanctName,
            contanctRole: this.contanctRole,
            contanctMobile: this.contanctMobile,
            catIds: this.isChange ? this.uniCatIds : undefined,
            mehvarIds: this.uniMehvarIds,
            articles: this.articles,
            otherFiles: this.otherFiles,
            researchAbstractFileId: this.researchAbstractFileData
              ? this.researchAbstractFileData.id
              : undefined,
            industryAbstractFileId: this.industryAbstractFileData
              ? this.industryAbstractFileData.id
              : undefined,
            centersAbstractFileId: this.centersAbstractFileData
              ? this.centersAbstractFileData.id
              : undefined,
            committeesAbstractFileId: this.committeesAbstractFileData
              ? this.committeesAbstractFileData.id
              : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then(() => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          this.isSaving = false;
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          setTimeout(() => {
            this.showTop = false;
          }, 1500);
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },

    submit() {
      this.isSaving = true;

      this.articles = this.articles.length
        ? this.articles.filter((x) => x.doi)
        : undefined;
      this.otherFiles = this.otherFiles.length
        ? this.otherFiles
            .filter((x) => x.fileId)
            .map((x) => {
              return { description: x.description, fileId: x.fileId };
            })
        : undefined;

      this.$http
        .patch(
          this.baseUrl + "/setad/university/demand/submit/" + this.demand.id,
          {
            isConfirmed: this.isConfirmed,
            isChange: this.isChange,
            contanctName: this.contanctName,
            contanctRole: this.contanctRole,
            contanctMobile: this.contanctMobile,
            catIds: this.isChange ? this.uniCatIds : undefined,
            mehvarIds: this.uniMehvarIds,
            articles: this.articles,
            otherFiles: this.otherFiles,
            researchAbstractFileId: this.researchAbstractFileData
              ? this.researchAbstractFileData.id
              : undefined,
            industryAbstractFileId: this.industryAbstractFileData
              ? this.industryAbstractFileData.id
              : undefined,
            centersAbstractFileId: this.centersAbstractFileData
              ? this.centersAbstractFileData.id
              : undefined,
            committeesAbstractFileId: this.committeesAbstractFileData
              ? this.committeesAbstractFileData.id
              : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.isSaving = false;
          router.push("/university/dashboard");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },
    submitEdit() {
      this.isSaving = true;

      this.articles = this.articles.length
        ? this.articles.filter((x) => x.doi)
        : undefined;
      this.otherFiles = this.otherFiles.length
        ? this.otherFiles
            .filter((x) => x.fileId)
            .map((x) => {
              return { description: x.description, fileId: x.fileId };
            })
        : undefined;

      this.$http
        .patch(
          this.baseUrl + "/setad/university/demand/edit/" + this.demand.id,
          {
            isConfirmed: this.isConfirmed,
            isChange: this.isChange,
            contanctName: this.contanctName,
            contanctRole: this.contanctRole,
            contanctMobile: this.contanctMobile,
            catIds: this.isChange ? this.uniCatIds : undefined,
            mehvarIds: this.uniMehvarIds,
            articles: this.articles,
            otherFiles: this.otherFiles,
            researchAbstractFileId: this.researchAbstractFileData
              ? this.researchAbstractFileData.id
              : undefined,
            industryAbstractFileId: this.industryAbstractFileData
              ? this.industryAbstractFileData.id
              : undefined,
            centersAbstractFileId: this.centersAbstractFileData
              ? this.centersAbstractFileData.id
              : undefined,
            committeesAbstractFileId: this.committeesAbstractFileData
              ? this.committeesAbstractFileData.id
              : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.isSaving = false;
          router.push("/university/dashboard");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },

    submitFinalize() {
      this.isSaving = true;

      this.$http
        .patch(
          this.baseUrl + "/setad/university/demand/finalize/" + this.demand.id,
          {
            finalLetterFileId: this.finalLetterFileData
              ? this.finalLetterFileData.id
              : undefined,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.isSaving = false;
          router.push("/university/dashboard");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.isSaving = false;
        });
    },

    onMounted() {
      this.isLoaded = false;
      //getting info
      this.$http
        .get(this.baseUrl + "/setad/university/demand/", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.demand = res.data;
          this.researchAbstractFileData = this.demand.researchAbstractFileId
            ? {
                id: this.demand.researchAbstractFileId,
                name: this.demand.researchAbstractFileName,
                url: this.demand.researchAbstractFileUrl,
              }
            : {};
          this.industryAbstractFileData = this.demand.industryAbstractFileId
            ? {
                id: this.demand.industryAbstractFileId,
                name: this.demand.industryAbstractFileName,
                url: this.demand.industryAbstractFileUrl,
              }
            : {};
          this.centersAbstractFileData = this.demand.centersAbstractFileId
            ? {
                id: this.demand.centersAbstractFileId,
                name: this.demand.centersAbstractFileName,
                url: this.demand.centersAbstractFileUrl,
              }
            : {};
          this.committeesAbstractFileData = this.demand.committeesAbstractFileId
            ? {
                id: this.demand.committeesAbstractFileId,
                name: this.demand.committeesAbstractFileName,
                url: this.demand.committeesAbstractFileUrl,
              }
            : {};
          this.finalLetterFileData = this.demand.finalLetterFileId
            ? {
                id: this.demand.finalLetterFileId,
                name: this.demand.finalLetterFileName,
                url: this.demand.finalLetterFileUrl,
              }
            : {};
          this.otherFiles = this.demand.otherFiles.length
            ? this.demand.otherFiles
            : [
                {
                  description: "",
                  fileId: "",
                  file: {},
                  rawFile: [],
                },
              ];
          this.contanctName = this.demand.contanctName;
          this.contanctRole = this.demand.contanctRole;
          this.contanctMobile = this.demand.contanctMobile;
          this.articles = this.demand.articles.length
            ? this.demand.articles
            : [{ title: "", doi: "" }];
          this.isConfirmed = this.demand.isConfirmed;
          this.isChange = this.demand.isChange;
          this.uniCats = res.data.cats;
          this.uniCatIds = res.data.catIds;
          this.uniMehvarIds = res.data.mehvarIds;
          if (
            this.demand.status == "نیاز به تکمیل / اصلاح" ||
            this.demand.status == "پیش نویس"
          ) {
            if (!this.uniCats.length) {
              this.isChange = true;
              this.isConfirmed = false;
              this.uniCatsDisabled = true;
            }
          }
          if (this.uniCatIds.length) this.getMehvarByCats();
          if (this.isConfirmed) this.getConfirmMehvarByCats();
          this.showMehvarSelection = this.demand.isChange
            ? this.uniCatIds.length
              ? true
              : false
            : this.isConfirmed
            ? true
            : false;
          this.isProposed = this.uniMehvarIds.length ? true : false;

          this.notEditable =
            this.demand.status == "نیاز به تکمیل / اصلاح" ||
            this.demand.status == "پیش نویس"
              ? false
              : true;
          this.isFinalize = this.demand.status == "پذیرش اولیه" ? true : false;
          // this.notEditable = false;

          setTimeout(() => {
            // NOTE (m-setTimeout) to set timeout for 200 ms
            this.show = true;
            this.pageLoaded = true;
          }, 200);

          this.fileBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });

      this.$bvModal.show("loading");
      this.isLoaded = true;
    },
    getCats() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/cats/list",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.categories = res.data.map((x) => {
            return {
              id: x.id,
              text: x.name,
            };
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    onSelectCategory() {
      if (this.uniCatIds.length > 2) {
        this.uniCatIds.pop();
        this.toast("فقط می‌توانید حداکثر دو دسته انتخاب کنید.", "error");
      }
    },
    removeCatIds() {
      this.uniCatIds = [];
    },
    getMehvarByCats() {
      this.$http
        .post(
          this.baseUrl + "/setad/options/mehvarByCats",
          { catIds: this.uniCatIds },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getConfirmMehvarByCats() {
      let catIds = this.uniCats.map((x) => x.id);
      this.$http
        .post(
          this.baseUrl + "/setad/options/mehvarByCats",
          { catIds: catIds },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.mehvars = res.data;
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    checkNotConfirm() {
      this.uniCatIds = this.demand.catIds.length ? this.demand.catIds : [];
      this.uniMehvarIds = this.demand.catIds.length
        ? this.demand.mehvarIds.length
          ? this.demand.mehvarIds
          : []
        : [];
      if (this.uniCatIds.length) this.getMehvarByCats();
      if (!this.uniCatIds.length) this.showMehvarSelection = false;
      if (this.uniMehvarIds.length) {
        this.showMehvarSelection = true;
        this.isProposed = true;
      } else this.isProposed = false;
    },
    checkConfirm() {
      this.showMehvarSelection = true;
      this.uniMehvarIds = this.demand.mehvarIds.length
        ? this.demand.mehvarIds
        : [];
      this.isProposed = false;
    },
    // onSelectMehvar(event) {
    //   if (this.uniMehvarIds.length > 2) {
    //     this.uniMehvarIds.pop();
    //     this.toast("فقط می‌توانید حداکثر دو محور انتخاب کنید.", "error");
    //   }
    // },
    removeMehvarIds() {
      this.uniMehvarIds = [];
    },
  },
  computed: {
    isMobileValid() {
      const regex = /^09\d{9}$/;
      return regex.test(this.contanctMobile);
    },
    submitButton() {
      if (this.isSaving) return true;
      else {
        if (
          (this.isConfirmed && this.uniMehvarIds.length) ||
          (this.isChange && this.uniCatIds.length && this.uniMehvarIds.length)
        ) {
          if (!Object.keys(this.researchAbstractFileData).length) return true;
          else if (!Object.keys(this.centersAbstractFileData).length)
            return true;
          else if (!Object.keys(this.committeesAbstractFileData).length)
            return true;
          else if (!this.articles.filter((x) => x.doi).length) return true;
          else if (!this.contanctName) return true;
          else if (!this.contanctRole) return true;
          else if (!this.isMobileValid) return true;
          else return false;
        } else return true;
      }
    },
    finalizeButton() {
      if (this.isSaving) return true;
      else {
        if (this.isFinalize) {
          if (!Object.keys(this.finalLetterFileData).length) return true;
          else return false;
        } else return true;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
    this.onMounted();
    this.getCats();
  },
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
ul {
  list-style: disc !important;
  padding-right: 1.5rem !important;
}
.dialog-card {
  border-radius: 15px !important;
  padding: 25px;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
